import { RemoteData } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { IMessage } from 'domain/message/message';

import { SendMessageCmd } from '../command/send-message.cmd';
import { ObserveMessagesQuery } from '../query/observe-messages.query';

export abstract class MessageApplicationPort {
	public abstract fetchMessages(
		query: ObserveMessagesQuery
	): Observable<string[] | Error>;

	public abstract observeMessages(
		query: ObserveMessagesQuery
	): Observable<IMessage[]>;

	public abstract markMessagesRead(messagesId: string[]): Promise<void>;

	public abstract sendMessage(cmd: SendMessageCmd): Promise<void>;
}
